import script from "./ViewEliBudgetPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewEliBudgetPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewEliBudgetPage.vue?vue&type=style&index=0&id=bcf33f94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcf33f94"]])

export default __exports__